import { orderStatusDisplay, type OrderStatusTone } from './orderStatusDisplay'

// Each status's hue from the design spec, as a tinted pill that keeps its text
// at 4.5:1 or better in both themes.
const TONE_CLASS: Record<OrderStatusTone, string> = {
  slate:
    'bg-slate-100 text-slate-700 border-slate-200 dark:bg-zinc-800 dark:text-zinc-300 dark:border-zinc-700',
  blue:
    'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/40 dark:text-blue-300 dark:border-blue-800/60',
  amber:
    'bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800/60',
  violet:
    'bg-violet-50 text-violet-700 border-violet-200 dark:bg-violet-950/40 dark:text-violet-300 dark:border-violet-800/60',
  teal:
    'bg-teal-50 text-teal-700 border-teal-200 dark:bg-teal-950/40 dark:text-teal-300 dark:border-teal-800/60',
  green:
    'bg-green-50 text-green-700 border-green-200 dark:bg-green-950/40 dark:text-green-300 dark:border-green-800/60',
}

/** The order's workflow status, named and coloured the same on every screen. */
export function OrderStatusBadge({ status }: { status?: string | null }) {
  const { label, tone } = orderStatusDisplay(status)
  return (
    <span
      data-testid="order-status"
      data-tone={tone}
      className={`inline-flex items-center justify-center whitespace-nowrap px-2.5 py-0.5 rounded-full text-xs font-semibold border ${TONE_CLASS[tone]}`}
    >
      {label}
    </span>
  )
}
